import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TrackAuthority } from '../../models/trackauthority';

@Component({
  selector: 'available-authority',
  templateUrl: './available-authority.component.html',
  styleUrls: ['./available-authority.component.scss']
})
export class AvailableAuthorityComponent {
  @Input() authorities: TrackAuthority[];
  @Output() availableAuthorities: EventEmitter<TrackAuthority> = new EventEmitter();
  @Output() requestNew: EventEmitter<void> = new EventEmitter();

  showAuthorities(authority): void {
    this.availableAuthorities.emit(authority);
  }

  showRequestNewBox(): void {
    this.requestNew.emit();
  }
}
